var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewBanner'),_c('Partners'),_c('div',{staticClass:"imagePartners scroll"}),_c('why-kneek'),_c('div',{staticClass:"imageOne scroll"}),_c('build-merch-banner'),_c('div',{staticClass:"imageTwo scroll"}),_c('testimonials'),_c('fundraiser-section'),_c('start-creating-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }